import { RouteConfig } from "vue-router";
import TransactionDetails from "./views/transaction-details/TransactionDetails";
import Transactions from "./views/transactions/Transactions";

export default [
  {
    path: "/dashboard/transactions",
    component: Transactions,
    meta: { title: "Transactions" },
  },
  {
    path: "/dashboard/transactions/details",
    component: TransactionDetails,
    props: (route) => route.query,
    meta: { title: "Transaction Details" },
  },
] as RouteConfig[];
